'use client';

import IconArrowLeft from '@/assets/icons/profile-popup/icon-arrow-left.svg';

import IconCode from '@/assets/icons/profile-popup/icon-password-check.svg';

import Input from '@/components/ui/input';

import { Controller, useForm } from 'react-hook-form';

import styles from './password.module.scss';

import { useEffect, useRef, useState } from 'react';

import { useAuthStore } from '@/zustand/useAuth';

import { useMutation } from '@apollo/client';

import { AUTHENTICATE_CUSTOMER } from '@/apollo/graphql/mutations/authMutations/authenticateCustomerMutations';

import useUserStore from '@/zustand/useUser';

import {
  SEND_OTP_MUTATION,
  VERIFY_OTP_MUTATION,
} from '@/apollo/graphql/mutations/authMutations/otpMutations';
import useIsBuying from '@/zustand/useIsBuying';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';

type OnCloseHandler = () => void;

const PasswordContent = ({ onClose }: { onClose: OnCloseHandler }) => {
  const cabinetRef = useRef<HTMLFormElement>(null);
  const [countdown, setCountdown] = useState(40);
  const router = useRouter();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const t = useTranslations('Drawer.Password-content');

  const { setUser } = useUserStore();

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setError,
  } = useForm({
    defaultValues: {
      password: '',
    },
  });

  const storedPhone = useAuthStore(state => state.phone);
  const isBuying = useIsBuying(state => state.isBuying);

  const [authenticateCustomer, { loading: authLoading }] = useMutation(
    AUTHENTICATE_CUSTOMER
  );

  // const [createCustomerToken, { loading: tokenLoading }] = useMutation(
  // 	CUSTOMER_CREATE_TOKEN
  // )

  const [sendOtp, { loading: sendOtpLoading }] = useMutation(SEND_OTP_MUTATION);

  const [verifyOtp, { loading: verifyOtpLoading }] =
    useMutation(VERIFY_OTP_MUTATION);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);

      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSendOtp = async () => {
    try {
      const response = await sendOtp({ variables: { phone: storedPhone } });

      if (response.data?.sendOtp?.status) {
        setCountdown(40);
      } else {
        console.error(
          'Ошибка повторной отправки OTP:',

          response.data?.sendOtp?.errors
        );
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  };
  const onSubmit = async (data: { password: string }) => {
    setIsSubmitting(true);

    try {
      const verifyOtpResponse = await verifyOtp({
        variables: { otp: data.password, phone: storedPhone },
      });

      if (!verifyOtpResponse.data?.verifyOtp?.status) {
        setError('password', {
          type: 'manual',
          message: t('error-msg'),
        });
        setIsSubmitting(false);
        return;
      }

      await authenticateCustomer({
        variables: {
          phone: storedPhone,
          input: { channel: 'default-channel' },
        },
      });

      // Create token via API route
      try {
        const response = await fetch('/api/auth', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ storedPhone }),
          credentials: 'include',
        });

        if (!response.ok) {
          console.error(`API error: ${response.status} ${response.statusText}`);
          return;
        }

        const result = await response.json();

        if (result.success) {
          setUser(result.user);
          onClose();

          if (isBuying) {
            router.push('/order');
          }
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }

      onClose(); // Close only after successful authentication
    } catch (error) {
      console.error('Ошибка авторизации:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cabinetRef.current &&
        !cabinetRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <form
      className={styles.passwordWrapper}
      onSubmit={handleSubmit(onSubmit)}
      ref={cabinetRef}
    >
      {/* <div className={styles.mobileHeader}>
        <button type="button" onClick={onClose}>
          <IconArrowLeft />
        </button>

        <h4>{t('confirm')}</h4>
      </div> */}

      <div className={styles.iconCode}>
        <IconCode />
      </div>

      <h3>{t('sms-code')}</h3>

      <div className={styles.userPhone}>
        {t('sending-number')} <p>{storedPhone}</p>
      </div>

      <Controller
        name="password"
        control={control}
        rules={{
          required: 'Введите OTP код',

          validate: value =>
            value.length === 6 || t('password-input.validation-msg'),
        }}
        render={({ field }) => (
          <Input
            modalInput
            state={field.value}
            setState={async value => {
              const numericValue = value.replace(/\D/g, '').slice(0, 6);

              field.onChange(numericValue);

              if (numericValue.length === 6) {
                await trigger('password');

                handleSubmit(onSubmit)();
              }
            }}
            label={t('password-input.label')}
            error={errors}
            name="password"
            className={styles.input}
          />
        )}
      />

      {isSubmitting ? (
        <p className={styles.info}>{t('auth')}</p>
      ) : countdown > 0 ? (
        <p className={styles.info}>{t('recend-code', { count: countdown })}</p>
      ) : (
        <button
          type="button"
          className={styles.resendInfo}
          onClick={handleSendOtp}
          disabled={sendOtpLoading}
        >
          {sendOtpLoading ? t('sending') : t('resend')}
        </button>
      )}
    </form>
  );
};

export default PasswordContent;
